import { call, put, takeEvery } from "redux-saga/effects";

import {
    GET_AZURE_THRESHOLD, POST_DISABLE_AZURE_THRESHOLD_ALERTS, POST_ENABLE_AZURE_THRESHOLD_ALERTS, PUT_AZURE_THRESHOLD,
} from "./actionTypes";


import {
    getAzureThresholdSuccess,
    getAzureThresholdFail,
    putAzureThresholdSuccess,
    putAzureThresholdFail,
    postDisableAzureThresholdAlertsSuccess,
    postDisableAzureThresholdAlertsFail,
    postEnableAzureThresholdAlertsSuccess,
    postEnableAzureThresholdAlertsFail,
} from "./actions";

import {
    getAzureThreshold,
    postUpdateAzureThresholdUrl,
    postDisableAzureThresholdAlertUrl,
    postEnableAzureThresholdAlertUrl
} from "../../helpers/fakebackend_helper";
import { showNotification } from "components/Common/notification";

function* onGetAzureThreshold(metric_id) {
    try {
        const response = yield call(getAzureThreshold, metric_id.payload);
        yield put(getAzureThresholdSuccess(response));
    } catch (error) {
        yield put(getAzureThresholdFail(error));
    }
}

function* onPutThreshold({ payload: { data } }) {
    try {
        const response = yield call(postUpdateAzureThresholdUrl, data);
        yield put(putAzureThresholdSuccess(response));
        if (response) {
            showNotification("success", "Updated AZURE Threshold successfully!");
        }
    } catch (error) {
        yield put(putAzureThresholdFail(error.message));
        if (error) {
            showNotification("error", "Failed to update AZURE Threshold");
        }
    }
}

function* onPostDisableAzureThresholdAlerts({ payload: { data } }) {
    try {
        const response = yield call(postDisableAzureThresholdAlertUrl, data);
        yield put(postDisableAzureThresholdAlertsSuccess(response));
        if (response) {
            showNotification("success", "Disabled AZURE Threshold successfully!");
        }
        window.location.reload();
    } catch (error) {
        yield put(postDisableAzureThresholdAlertsFail(error.message));
        if (error) {
            showNotification("error", "Failed to disable AZURE Threshold");
        }
    }
}

function* onPostEnableAzureThresholdAlerts({ payload: { data } }) {
    try {
        const response = yield call(postEnableAzureThresholdAlertUrl, data);
        yield put(postEnableAzureThresholdAlertsSuccess(response));
        if (response) {
            showNotification("success", "Enabled AZURE Threshold successfully!");
        }
        window.location.reload();
    } catch (error) {
        yield put(postEnableAzureThresholdAlertsFail(error.message));
        if (error) {
            showNotification("error", "Failed to enable AZURE Threshold");
        }
    }
}

function* AzureThresholdSaga() {
    yield takeEvery(GET_AZURE_THRESHOLD, onGetAzureThreshold);
    yield takeEvery(PUT_AZURE_THRESHOLD, onPutThreshold);
    yield takeEvery(POST_ENABLE_AZURE_THRESHOLD_ALERTS, onPostEnableAzureThresholdAlerts);
    yield takeEvery(POST_DISABLE_AZURE_THRESHOLD_ALERTS, onPostDisableAzureThresholdAlerts);
}

export default AzureThresholdSaga;
